import { RecoveryScreen } from "../../screen/RecoveryScreen"

export const RecoveryContainer = () => {
    return <RecoveryScreen />
}